import React from "react";
import { t } from "ttag";

import { GridItem, SortType } from "../interfaces";
import { Grid } from "./Grid";
import { SearchField } from "./SearchField";
import { SortDropdown } from "./SortDropdown";

interface Props {
    filterBy?: number | null;
    baseApiUrl: string;
}

interface State {
    gridData: GridItem[];
    sortType: SortType;
    nextUrl: string | null;
    appendItems: boolean;
}

// TODO(ssr, LEVEL 5 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 5/10 due to state management for filtering/searching, async data loading, componentDidMount lifecycle, and search result filtering logic.
export class TempurLoveGrid extends React.Component<Props, State> {
    state: State = {
        gridData: [],
        sortType: "-date",
        nextUrl: null,
        appendItems: false,
    };

    componentDidMount(): void {
        this.updateGrid();
    }

    componentDidUpdate(_prevProps: Props, prevState: State): void {
        if (prevState.sortType !== this.state.sortType) {
            this.updateGrid();
        }
    }

    private readonly updateGrid = async (
        searchString?: string,
    ): Promise<void> => {
        const apiURL = new URL(this.props.baseApiUrl);
        apiURL.searchParams.set("ordering", this.state.sortType);

        if (this.props.filterBy) {
            apiURL.searchParams.set("category", `${this.props.filterBy}`);
        }
        if (searchString) {
            apiURL.searchParams.set("search", searchString);
        }

        const response = await fetch(apiURL.toString());
        const data = await response.json();
        this.setState({
            gridData: data.results,
            nextUrl: data.next,
            appendItems: false,
        });
    };

    private readonly loadMore = async (): Promise<void> => {
        // The button that calls this should never be shown unless this exists, so this if statement is here mostly to satisfy typescript
        if (this.state.nextUrl) {
            const response = await fetch(this.state.nextUrl);
            const data = await response.json();
            this.setState((state) => ({
                gridData: [...state.gridData, ...data.results],
                nextUrl: data.next,
                appendItems: true,
            }));
        }
    };

    render(): React.JSX.Element {
        return (
            <>
                <div className="l-full-width">
                    <div className="l-capped-width">
                        <article className="search">
                            <SearchField onSearch={this.updateGrid} />
                            <SortDropdown
                                onChange={(e) => {
                                    this.setState({
                                        sortType: e.target.value as SortType,
                                    });
                                }}
                                value={this.state.sortType}
                            />
                        </article>
                    </div>
                </div>
                {this.state.gridData.length > 0 && (
                    <Grid
                        data={this.state.gridData}
                        appendItems={this.state.appendItems}
                    />
                )}
                {this.state.nextUrl && (
                    <button
                        className="button button--full-width button--alabaster load-more-posts al-tempur-love--load-more-posts"
                        onClick={this.loadMore}
                    >
                        {t`Load More Posts`}
                    </button>
                )}
            </>
        );
    }
}
